var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.499,
    height: 37.502,
    viewBox: "0 0 37.499 37.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-bold",
    transform: "translate(-3.751 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10547",
    "data-name": "Path 10547",
    d: "M10.37,31.556l-.731,5.925a1.866,1.866,0,0,0,2.812,1.838l6.488-3.863a.936.936,0,0,0,.319-1.275,11.842,11.842,0,0,1-1.444-5.625c0-6.862,5.888-12.45,13.125-12.45a13.517,13.517,0,0,1,4.275.675.947.947,0,0,0,1.2-1.125C34.707,8.831,28.145,3.75,20.307,3.75c-9.15,0-16.556,6.919-16.556,15.45A15.1,15.1,0,0,0,10.37,31.556Z",
    fill: "#fd792f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10548",
    "data-name": "Path 10548",
    d: "M20.625,28.556a9.114,9.114,0,0,0,2.212,5.925,10.47,10.47,0,0,0,8.1,3.694l4.894,2.906a1.173,1.173,0,0,0,1.763-1.144l-.469-3.694a9.253,9.253,0,0,0-.338-15.619,10.656,10.656,0,0,0-5.85-1.706C25.237,18.919,20.625,23.231,20.625,28.556Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBold);
export default __webpack_public_path__ + "static/media/message-bold.27a305e7a0933dc6f9d126868062dc95.svg";
export { ForwardRef as ReactComponent };